var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.filtros.length
    ? _c(
        "div",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip.top-center",
              value: { content: _vm.textoCompleto, html: false },
              expression: "{ content: textoCompleto, html: false }",
              modifiers: { "top-center": true },
            },
          ],
          staticClass: "resumen-filtros",
        },
        [
          _c("i", {
            staticClass: "fa fa-filter",
            attrs: { "aria-hidden": "true" },
          }),
          _c(
            "p",
            { staticClass: "resumen-filtros__texto" },
            _vm._l(_vm.filtros, function (filtro) {
              return _c(
                "span",
                { key: filtro.key, staticClass: "resumen-filtros__item" },
                [
                  _c("span", { staticClass: "resumen-filtros__etiqueta" }, [
                    _vm._v(_vm._s(filtro.label) + ":"),
                  ]),
                  _c("span", { staticClass: "resumen-filtros__valor" }, [
                    _vm._v(_vm._s(filtro.value)),
                  ]),
                ]
              )
            }),
            0
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }